import { Service }			from "./../../Libs/Service";
import _					from "lodash";

import { Server } 			from "./Server";

import SetupSettings 		from "./../settings/settings.json";

let Asset = new Service({

	Name: "Asset",

	Events: {

		'Settings Selected': function(settings) {

			//this.updateParams();

		}

	},

	Actions: {

		'Assets': function(assets) {

			this.updateAssets(assets);

			Broadcast.call("Assets Updated", [assets]);

			if (!this.loaded) Broadcast.call("Assets Loaded");

			this.loaded = true;

		},

		'Videos': function(videos) {

			this.updateVideos(videos);

			Broadcast.call("Videos Updated", [videos]);

		},

		'AssetChanged': function(data) {

			if (this.Assets[data[0]]) this.Assets[data[0]].timestamp = new Date();

			Broadcast.call("Asset Changed", [data[0], data[1]]);

		},

		"CompressionCacheSize": function(size) {

			this.CompressionCacheSize = size;

			Broadcast.call("Compression Cache Size Changed");

		},

		"CreateVideo": function (data) {

			if (data === 'Video already exists') {
				Broadcast.call('Video Already Exists');
			}
			else if (data === 'An error occurred') {
				Broadcast.call('Video Error Occurred');
			}
			else {
				this.error = null;
				this.Videos[data.title] = data;
				Broadcast.call('Video Created', [this.Videos[data.title]]);
			}

		},

		"VideoRemoved": function (title) {
			delete this.Videos[title];
			Broadcast.call('Video Removed');
		}

	},

	init() {

		this.loaded = false;

		this.Assets = {};
		this.AssetsByProject = {};
		this.AssetsByProjectByCodename = {};
		this.Videos = {};

	},

	updateVideos(videos) {

		_.each(videos, (video) => {
			this.Videos[video.title] = video;
		});

	},

	updateAssets(assets) {

		let is_selected_project_assets_changed = false;

		_.each(assets, (asset, asset_id) => {

			if (!asset) {

				asset = this.Assets[asset_id];

				if (asset) {

					delete this.Assets[asset.id];
					if (this.AssetsByProject[asset["project_id"]]) delete this.AssetsByProject[asset["project_id"]][asset.id];
					if (this.AssetsByProjectByCodename[asset["project_id"]]) delete this.AssetsByProjectByCodename[asset["project_id"]][asset.codename];

				}

			} else {

				this.Assets[asset.id] = asset;

				if (!this.AssetsByProject[asset["project_id"]]) this.AssetsByProject[asset["project_id"]] = {};
				this.AssetsByProject[asset["project_id"]][asset.id] = asset;

				if (!this.AssetsByProjectByCodename[asset["project_id"]]) this.AssetsByProjectByCodename[asset["project_id"]] = {};
				this.AssetsByProjectByCodename[asset["project_id"]][asset.codename] = asset;

				asset.timestamp = new Date(asset.timestamp);
				asset.isChanged = this.isChangedAsset(asset);

				let templateAsset = Metadata.TemplateAssetsByTemplateIdByCodename[asset["template_id"]][asset["codename"]];

				//Определение isPNG isJPG должно быть выше getMergedAsset так как эти маркеры используются в getMergedAsset -> getAssetActualUrl
				if (asset.url || (templateAsset && templateAsset.url)) {
					asset.isPNG = (asset.type === 'image' && (asset.url || templateAsset.url).toLowerCase().indexOf('png') > -1);
					asset.isJPG = (asset.type === 'image' && (asset.url || templateAsset.url).toLowerCase().indexOf('jpg') > -1);
					asset.isSVG = (asset.type === 'svg' && (asset.url || templateAsset.url).toLowerCase().indexOf('svg') > -1);
				}

				asset.mergedAssetData = this.getMergedAsset(asset, true);

				asset.hasCompression = asset.mergedAssetData && "compression" in asset.mergedAssetData;

			}

			if (_.values(assets).length === 1 && asset.codename === 'background') {

				let settings = Settings.getSelectedProjectSettingsByCodename();

				if (settings && settings['background-color']) {

					let img = new Image();

					img.crossOrigin = "";
					img.onload = () => {

						Settings.setSettingValue(settings['background-color'], Settings.getImageBorderColor(img));

						Broadcast.call("Preview Refresh");

					};

					img.src = asset.url;
				}

			}

			Broadcast.call("Asset Updated", [asset_id]);

			if (Project.SelectedProject && asset["project_id"] === Project.SelectedProject.id) is_selected_project_assets_changed = true;

		});

		if (is_selected_project_assets_changed) Broadcast.call("Selected Project Assets Changed");

	},

	//Возвращаем дефолтные ассеты текущей версии проекта
	getSelectedProjectAssets() {

		if (!Template.SelectedTemplate) return null;

		//Ассеты проекта
		if (Project.SelectedProject) {

			return _.values(this.AssetsByProject[Project.SelectedProject.id]);

		//Ассеты по умолчанию для шаблона
		} else {

			return _.values(_.cloneDeep(Metadata.TemplateAssetsByTemplateId[Template.SelectedTemplate.id]));

		}

	},

	getVideos() {
		return this.Videos;
	},

	//Возвращаем результат мержа начальных ассетов и их изменений
	getSelectedProjectMergedAssets() {

		let assets = this.getSelectedProjectAssets();

		let result = {};

		_.each(assets, asset => {

			//!!!Похожий код на серверной стороне есть - меняя что-то тут наверняка нужно изменить и на сервере

			let merged_asset = this.getMergedAsset(asset);

			if (merged_asset) result[asset.codename] = merged_asset;

		});

		return result;

	},

	getMergedAsset(asset, force) {

		//!!!Похожий код на серверной стороне есть - меняя что-то тут наверняка нужно изменить и на сервере

		if (!asset) return {};

		//Не добавляем отменённые ассеты
		if (!force && asset.Tags.disabled) return null;

		let mergedAsset = {};

		//Если передан ассет из темплейта
		if (asset.origin === 'template') {

			mergedAsset = _.extend(_.pick(asset, ["id", "type", "url", "timestamp"]), asset["AdditionalData"]);

			mergedAsset.styles = _.extend({}, asset["AdditionalData"]["styles"]);

			//mergedAsset.styles.backgroundImage = `url(${mergedAsset.url})`;

		} else {

			let templateAsset = Metadata.TemplateAssetsByTemplateIdByCodename[asset["template_id"]][asset["codename"]];


			if (templateAsset) {

				mergedAsset = _.extend(_.pick(templateAsset, ["id", "codename", "type", "url", "timestamp"]), templateAsset["AdditionalData"], _.pick(asset, ["id", "type", "timestamp"]), asset["AdditionalData"], {url: this.getAssetActualUrl(asset)});

				mergedAsset.styles = _.extend({}, templateAsset["AdditionalData"]["styles"], asset["AdditionalData"]["styles"]);

			}

			else {

				mergedAsset = _.extend(_.pick(asset, ["id", "codename", "type", "url", "timestamp"]), asset["AdditionalData"], {url: this.getAssetActualUrl(asset)});

				mergedAsset.styles = _.extend({}, asset["AdditionalData"]["styles"]);

			}

			//mergedAsset.styles.backgroundImage = `url(${mergedAsset.url})`;

		}

		if (asset.compressionData) {
			if (asset.compressionData.width && asset.compressionData.height) {
				mergedAsset.width = asset.compressionData.width;
				mergedAsset.height = asset.compressionData.height;
			}
		}

		return mergedAsset;

	},

	isChangedAsset(asset) {

		if (asset.origin === 'template') return false;

		if (!Metadata.TemplateAssetsByTemplateIdByCodename[asset.template_id][asset.codename]) return false;

		if (asset.url) return true;

		return false;

	},

	downloadAsset(asset) {

		let url = Asset.getAssetActualUrl(asset, {addTimestamp: true});

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);
		xhr.responseType = "blob";
		xhr.withCredentials = true;
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let imageUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = imageUrl;
			tag.download = asset.codename;
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();

	},

	addAsset(assets_config, file) {

		let formData = new FormData();

		formData.append("projectId", Project.SelectedProject.id);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/asset/add';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/asset/add';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				assets_config.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [assets_config]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			assets_config.isUploading = true;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.upload.onloadend = function(e) {

			assets_config.isUploading = false;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.send(formData);

	},

	addVideo(video_id, file) {

		let formData = new FormData();

		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/video/add/' + video_id;
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/video/add/' + video_id;

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.send(formData);

	},

	replaceAsset(asset, file) {

		let formData = new FormData();

		formData.append("assetId", asset.id);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/asset/replace';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/asset/replace';

		let xhr = new XMLHttpRequest();

		xhr.withCredentials = true;

		xhr.open("POST", url);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	resetAsset(asset) {

		Server.sendToSocket({
			ResetAsset: asset.id
		});

	},

	removeAsset(asset) {

		if (asset.type === 'image' || asset.type === 'svg') {
			Server.sendToSocket({
				RemoveAsset: asset.id
			});
		}
		if (asset.guid) {
			Server.sendToSocket({
				RemoveVideo: asset.guid
			});
		}

	},

	disableAsset(asset) {

		Server.sendToSocket({
			DisableAsset: asset.id
		});

	},

	enableAsset(asset) {

		Server.sendToSocket({
			EnableAsset: asset.id
		});

	},

	setAssetProperty(asset, property_name, value) {

		Server.sendToSocket({
			SetAssetProperty: {
				assetId: asset.id,
				propertyName: property_name,
				propertyValue: value
			}
		});

	},

	createAsset(projectId, codename) {


		Server.sendToSocket({
			CreateAsset: {
				projectId: projectId,
				codename: codename,
				asset_type: 'image',
				url: '',
				additional_data: {},
				tags: ''
			}
		});
	},

	createImageNavigation(section) {
		let numberOfScreens = section.Data['numberOfScreens'] ? parseInt(section.Data['numberOfScreens']) : 4;

		for (let i = 0; i < numberOfScreens; i++) {
			Server.sendToSocket({
				CreateAsset: {
					projectId: section.project_id,
					codename: `navigation-${i + 1}`,
					asset_type: 'image',
					url: '',
					additional_data: {"tinyPng": true},
					tags: 'custom'
				}
			});
		}

	},

	compressAssets(asset_ids) {

		Server.sendToSocket({
			CompressAssets: asset_ids
		});

	},

	getAssetActualUrl(asset, options = {}) {

		if (asset.type === 'image' || asset.type === 'svg') {

			let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${asset.origin}-asset/get/${asset.id}`;

			if (asset.isPNG) url += '.png';
			if (asset.isJPG) url += '.jpg';
			if (asset.isSVG) url += '.svg';

			if (options.addTimestamp) url += `?v=${asset.timestamp.getTime()}`;

			return url;

		} else {

			let url = asset.url;

			if (url.indexOf('http') !== 0 && url.indexOf('data:') !== 0) url = Project.getSelectedProjectAssetsPath() + url;

			if (options.addTimestamp) url += `?v=${asset.timestamp.getTime()}`;

			return url;

		}

	},

	clearCompressionCache(projectId) {

		Server.sendToSocket({
			ClearCompressionCache: projectId
		});

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Asset = Asset;

export { Asset }

